import { Button, ButtonGroup, Menu, styled } from '@mui/material';

interface StyleProps {
  dotsColor?: string;
}

const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'dotsColor',
})<StyleProps>(({ dotsColor }) => ({
  color: dotsColor ?? 'white',
  '&.MuiButtonGroup-grouped': {
    minWidth: '20px',
    maxWidth: '20px',
    padding: '0',
  },
}));

const StyledButtonGroup = styled(ButtonGroup)({
  verticalAlign: 'middle',
  marginLeft: '24px',
});

const StyledMenu = styled(Menu)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export { StyledButton, StyledButtonGroup, StyledMenu };
